import React from 'react';
import {
  FEATURE_FLAG_NAMES,
  useFeatureFlag,
  useFeatureFlagsReady
} from '../../hooks/useFeatureFlag';
import { useDesignPreference } from '../../utils/design';

/**
 * One address, both designs.
 *
 * The redesigned stages were built at addresses of their own — `/aifs-v2`, `/extraction-v2` — which
 * made "which design am I in" a property of the URL, and every link a chance to answer it wrong. A
 * page that decides for itself has no such link: you go to the AIFs of a period, and which one you
 * get is your own setting.
 *
 * The `-v2` addresses stay as aliases. Some links are simply easier to build there — the report's,
 * whose classic address needs a regulator and a member state in its path — and nothing gains from
 * breaking a bookmark.
 *
 * Gated on `v2_ui`: without the flag the classic page is the only page, whatever is stored.
 */
export default function DesignRoute({
  v2,
  classic
}: {
  v2: React.ReactNode;
  classic: React.ReactNode;
}) {
  const isV2UI = useFeatureFlag(FEATURE_FLAG_NAMES.V2_UI);
  const ready = useFeatureFlagsReady();
  const design = useDesignPreference();

  /* Nothing until the company's features have arrived. The flag reads false while they are in
     flight, and drawing the classic page on that answer means the reader watches it be replaced. */
  if (!ready) return null;

  return <>{isV2UI && design === 'v2' ? v2 : classic}</>;
}
